var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.3971V14.8971C13.5 15.2949 13.342 15.6764 13.0607 15.9577C12.7794 16.239 12.3978 16.3971 12 16.3971H3.75C3.35218 16.3971 2.97064 16.239 2.68934 15.9577C2.40804 15.6764 2.25 15.2949 2.25 14.8971V6.64706C2.25 6.24924 2.40804 5.86771 2.68934 5.5864C2.97064 5.3051 3.35218 5.14706 3.75 5.14706H8.25M11.25 2.89706H15.75M15.75 2.89706V7.39706M15.75 2.89706L7.5 11.1471",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/ExternalLink.c3060b08423811de70d9e6269f25e342.svg";
export { ForwardRef as ReactComponent };